import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_PERSONNELTRAINING_LOAD_BY_ID,
    ACTION_PERSONNELTRAINING_LOAD_FAILURE,
    ACTION_PERSONNELTRAINING_LOAD_SUCCESS,

    ACTION_PERSONNELTRAINING_CREATE,
    ACTION_PERSONNELTRAINING_CREATE_SUCCESS,
    ACTION_PERSONNELTRAINING_CREATE_FAILURE,

    ACTION_PERSONNELTRAINING_SAVE,
    ACTION_PERSONNELTRAINING_SAVE_SUCCESS,
    ACTION_PERSONNELTRAINING_SAVE_FAILURE,

    ACTION_PERSONNELTRAINING_VALIDATE,
    ACTION_PERSONNELTRAINING_VALIDATE_SUCCESS,
    ACTION_PERSONNELTRAINING_VALIDATE_FAILURE,

    ACTION_PERSONNELTRAINING_CLEAR,
    PersonnelTrainingAction,
    ACTION_PERSONNELTRAINING_LOAD_BY_PERSONNELID
} from '../actions/personnelTraining';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface IPersonnelTrainingState {
    formData: Dtos.PersonnelTraining | Dtos.PersonnelTraining[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
}

const initialState: IPersonnelTrainingState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
};


function loading(state: IPersonnelTrainingState, _isLoading: boolean): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: IPersonnelTrainingState,
    formData: Dtos.PersonnelTraining | Dtos.PersonnelTraining[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function loadFailure(state: IPersonnelTrainingState, responseStatus: Dtos.ResponseStatus): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IPersonnelTrainingState, propertiesToClear?: string[]): IPersonnelTrainingState {

    if (!propertiesToClear) {
        const newState: IPersonnelTrainingState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function creating(state: IPersonnelTrainingState, _isCreating: boolean): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IPersonnelTrainingState,
    formData: Dtos.PersonnelTraining,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IPersonnelTrainingState, responseStatus: Dtos.ResponseStatus): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function saving(state: IPersonnelTrainingState, _isSaving: boolean): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IPersonnelTrainingState,
    formData: Dtos.PersonnelTraining | Dtos.PersonnelTraining[],
    formState: Dtos.FormState,
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        lookups: {
            $set: lookups
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IPersonnelTrainingState, responseStatus: Dtos.ResponseStatus): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function validating(state: IPersonnelTrainingState, _isValidating: boolean): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IPersonnelTrainingState,
    formData: Dtos.PersonnelTraining,
    formState: Dtos.FormState,
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        lookups: {
            $set: lookups
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IPersonnelTrainingState, responseStatus: Dtos.ResponseStatus): IPersonnelTrainingState {
    const newState: IPersonnelTrainingState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const PersonnelTrainingReducer: Reducer<IPersonnelTrainingState> = (state: IPersonnelTrainingState = initialState, action: PersonnelTrainingAction) => {
    switch (action.type) {
        case ACTION_PERSONNELTRAINING_LOAD_BY_ID:
        case ACTION_PERSONNELTRAINING_LOAD_BY_PERSONNELID:
            return loading(state, true);
        case ACTION_PERSONNELTRAINING_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_PERSONNELTRAINING_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_PERSONNELTRAINING_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_PERSONNELTRAINING_CREATE:
            return creating(state, true);
        case ACTION_PERSONNELTRAINING_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_PERSONNELTRAINING_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_PERSONNELTRAINING_SAVE:
            return saving(state, true);
        case ACTION_PERSONNELTRAINING_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.lookups, action.responseStatus);
        case ACTION_PERSONNELTRAINING_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_PERSONNELTRAINING_VALIDATE:
            return validating(state, true);
        case ACTION_PERSONNELTRAINING_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.lookups, action.responseStatus);
        case ACTION_PERSONNELTRAINING_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
    }

    return state;
}

export default PersonnelTrainingReducer;